import React, { useContext, useEffect, useMemo, useRef } from 'react'
import Select, { components } from 'react-select'
import { bubble } from '../../../js/utils/bubble'
import { isMedia } from '../../../js/utils/isMedia'
import { filterSelectColors, mq, AppContext } from '../constants'
import { getInitialSelectOption } from '../utils'

const FilterSelect = ({ options, name, value }) => {
  const { formRef, formId } = useContext(AppContext)

  const onSelectChange = (e) => {
    if (formRef) {
      bubble(formRef.current, 'submit')
    }
  }

  const selectStyles = useMemo(() => {
    return {
      option: (styles, { isFocused, isSelected }) => {
        return {
          ...styles,
          backgroundColor: isSelected
            ? filterSelectColors.backgroundColor.selected
            : isFocused
              ? filterSelectColors.backgroundColor.focused
              : undefined,
          color: isFocused && !isSelected
            ? filterSelectColors.textColor.focused
            : filterSelectColors.textColor.selected,
          padding: '10px 12px',
          fontSize: 16
        }
      },
      valueContainer: styles => ({
        ...styles,
        padding: '10px 12px',
        fontSize: 16,
        fontWeight: 600
      }),
      dropdownIndicator: styles => ({
        ...styles,
        color: filterSelectColors.dropdownIndicator
      }),
      menu: base => ({
        ...base,
        marginTop: 2
      }),
      control: styles => ({
        ...styles,
        border: 0,
        borderRadius: 0

      })
    }
  }, [])

  const initialOption = getInitialSelectOption(options, value)

  const SelectContainer = ({ children, ...props }) => {
    children = children.filter(item => item && item.type !== 'input')
    const valueArr = props.getValue()

    return (
      <components.SelectContainer {...props}>
        {children}
        {valueArr.length ? valueArr.map(({ value }, index) => {
          return <input key={index} value={value} form={formId} name={name} type='hidden' />
        }) : <input value={''} form={formId} name={name} type='hidden' />}
      </components.SelectContainer>
    )
  }

  return (
    <Select
      defaultValue={initialOption}
      name={name}
      options={options}
      onChange={onSelectChange}
      components={{ IndicatorSeparator: () => null, SelectContainer }}
      styles={selectStyles}
      className={'currency-chart-ma__currency-filter'}
    />
  )
}

export default FilterSelect
